<template>
	<div>
		<div class="h3 ftw600" v-if="userInfo&&userInfo.nickname">
			{{ $t('userCenter.greeting') }} {{userInfo.nickname}}
		</div>
		<div class="mt-4 row">
			<!-- 左面部分 -->
			<div class="col-md-9">
				<div class=" ftr-1-25 ftw600 mb-3">
					{{ $t('userCenter.myClassPackage') }}
				</div>
				<div v-if="coursePackageList.length<=1">
					<div v-for="(t,i) in coursePackageList">
						<div class="flex">
							<div class="border-gray br4 p-2 wid-fit mt-2 mr15" style="width: 180px;"  v-for="(item,index) in t">
								<div class="d-flex align-items-center">
									<img :src="item.photo_image" alt="" class="userCenter-head" />
									<span class="ml10 ftw600">{{item.name}} {{item.surname}}</span>
								</div>
								<div class="mt-2 ft16">
									{{item.course_name}}
								</div>
								<div class="d-flex align-items-center ">
									<div class="mt-2 ft14">
										{{ $t('userCenter.classBalance') }}:{{item.residue_quantity}}{{$t('common.class') }}
									</div>
									<div class="btn btn-theme px-3 py-1 ft14 ml10" @click="toAppointment(item.id)">
										{{ $t('userCenter.appointment') }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<a-carousel arrows v-else>
					<div slot="nextArrow" class="custom-slick-arrow" style="right: 10px;z-index: 10;">
						<a-icon type="right-circle" />
					</div>
					<div v-for="(t,i) in coursePackageList">
						<div class="flex">
							<div class="border-gray br4 p-2 wid-fit mt-2 mr15" style="width: 180px;"  v-for="(item,index) in t">
								<div class="d-flex align-items-center">
									<img :src="item.photo_image" alt="" class="userCenter-head" />
									<span class="ml10 ftw600">{{item.name}} {{item.surname}}</span>
								</div>
								<div class="mt-2 ft16">
									{{item.course_name}}
								</div>
								<div class="d-flex align-items-center ">
									<div class="mt-2 ft14">
										{{ $t('userCenter.classBalance') }}:{{item.residue_quantity}}{{$t('common.class') }}
									</div>
									<div class="btn btn-theme px-3 py-1 ft14 ml10" @click="toAppointment(item.id)">
										{{ $t('userCenter.appointment') }}
									</div>
								</div>
							</div>
						</div>
					</div>


				</a-carousel>

				<div class="mt-5 ftr-1-25 ftw600 mb-2">
					{{ $t('userCenter.myCourses') }}
				</div>
				<div v-if="orderList.length<=1">
					<div v-for="(t,i) in orderList">
						<div class="flex">
							<div class="border-gray br4 py-2 mt-2 mr15 d-flex" style="width: 295px;"
								v-for="(item,index) in t">
								<div class=" text-center" style="border-right: 1px solid #D2D2D2;width: 75px;">
									<div class="ft14">
										{{convertToTimeZone(item.finish_time).date.month}}
										<!-- {{item.split_finish_time.month}}月 -->
									</div>
									<div class="ftr-2">
										<!-- {{item.split_finish_time.day}} -->
										{{convertToTimeZone(item.finish_time).date.day}}
									</div>
									<div class="cl-info ft14">
										<!-- 周{{item.split_finish_time.week}} -->
										{{changeNum( convertToTimeZone(item.finish_time).date.week)}}
									</div>
								</div>
								<div class="ml15">
									<div class="ft14">
										{{convertToTimeZone(item.start_time).date.hour}}:{{convertToTimeZone(item.start_time).date.minute}}
										-
										{{convertToTimeZone(item.finish_time).date.hour}}:{{convertToTimeZone(item.finish_time).date.minute}}
									</div>
									<div class="d-flex align-items-center mt-1">
										<img :src="item.photo_image" alt="" class="userCenter-head" />
										<span class="ml10 ftw600">{{item.name}}</span>
									</div>
									<div class="cl-theme ft14 clickAct mt-1" @click="toClass(item.id)">
										{{ $t('userCenter.viewClass') }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<a-carousel arrows v-else>
					<!-- <div slot="prevArrow" class="custom-slick-arrow" style="left: 10px;z-Index: 10;">
						<a-icon type="left-circle" />
					</div> -->
					<div slot="nextArrow" class="custom-slick-arrow" style="right: 10px;z-index: 10;">
						<a-icon type="right-circle" />
					</div>
					<div v-for="(t,i) in orderList">
						<div class="flex">
							<div class="border-gray br4 py-2 mt-2 mr15 d-flex" style="width: 295px;"
								v-for="(item,index) in t">
								<div class=" text-center" style="border-right: 1px solid #D2D2D2;width: 75px;">
									<div class="ft14">
										{{convertToTimeZone(item.finish_time).date.month}}
										<!-- {{item.split_finish_time.month}}月 -->
									</div>
									<div class="ftr-2">
										<!-- {{item.split_finish_time.day}} -->
										{{convertToTimeZone(item.finish_time).date.day}}
									</div>
									<div class="cl-info ft14">
										<!-- 周{{item.split_finish_time.week}} -->
										{{changeNum( convertToTimeZone(item.finish_time).date.week)}}
									</div>
								</div>
								<div class="ml15">
									<div class="ft14">
										{{convertToTimeZone(item.start_time).date.hour}}:{{convertToTimeZone(item.start_time).date.minute}}
										-
										{{convertToTimeZone(item.finish_time).date.hour}}:{{convertToTimeZone(item.finish_time).date.minute}}
									</div>
									<div class="d-flex align-items-center mt-1">
										<img :src="item.photo_image" alt="" class="userCenter-head" />
										<span class="ml10 ftw600">{{item.name}}</span>
									</div>
									<div class="cl-theme ft14 clickAct mt-1" @click="toClass(item.id)">
										{{ $t('userCenter.viewClass') }}
									</div>
								</div>
							</div>
						</div>
					</div>
				
				
				</a-carousel>
				
				
				<div class="mt-4 flex align-items-center flex-wrap">
					<div class="bg-F3F3F3 py-3 px-2 d-flex flex-column "
						style="width: 200px; height: 200px;" :class="workInfo.work_num!=0?'justify-content-between':''">
						<div class="ftw600">
							{{ $t('userCenter.myHomework') }}
						</div>
						<div class="" v-if="workInfo.work_num!=0">
							<div class="flex alcenter">
								<div class="ftr-3">
									{{workInfo.work_complete}}/
								</div>
								<div class="">
									<div class="ft12">
										{{workInfo.work_num}}
									</div>
									<div class="ft12 cl-info">
										{{ $t('userCenter.completedHomework') }}
									</div>
								</div>
							</div>
							<div class="progress" role="progressbar" aria-label="Danger example" aria-valuenow="100"
								aria-valuemin="0" aria-valuemax="100">
								<div class="progress-bar bg-danger"
									:style="'width:'+(workInfo.work_complete/workInfo.work_num)*100+'%'"></div>
							</div>
						</div>
						<div class="mt-3 cl-info px-3" v-else>
							<div class="">
								{{ $t('userCenter.good') }}
							</div>
							<div class="">
								{{ $t('userCenter.noIncompleteTest') }}
							</div>
						</div>
					</div>
					<div class="bg-F3F3F3 py-3 px-2 ms-sm-3 mm-r-t" style="width: 200px; height: 200px;">
						<div class="ftw600">
							{{ $t('userCenter.myTest') }}
						</div>
						<div class="mt-3 cl-info px-3">
							<div class="">
								{{ $t('userCenter.good') }}
							</div>
							<div class="">
								{{ $t('userCenter.noIncompleteTest') }}
							</div>
						</div>
					</div>
					<div class="bg-F3F3F3 py-3 px-2 ms-sm-3 mm-r-t d-flex flex-column justify-content-between "
						style="width: 200px; height: 200px;">
						<div class="ftw600">
							{{ $t('userCenter.learningReport') }}
						</div>
						<div class="ftw600 mb-2">
							<span class="mr15 ftr-1-25">{{workInfo.report_num}}</span>
							{{$t('userCenter.reportContent')}}
						</div>
					</div>
				</div>
				
				<div class="mt-5 ftr-1-25 ftw600" v-if="couponList.length!=0">
					{{ $t('userCenter.myCoupons') }}
				</div>
				<div class="mt-2 flex flex-wrap">
					<div class="border-gray mr10" style="border-top: 2px solid #02CAB9 !important;" v-for="(item,index) in couponList">
						<div class="p-2 border-b">
							<!-- // {{ $t('userCenter.newUserCoupon') }} -->
							{{item.name}}
						</div>
						<div class="p-2">
							<div class="ft20 ftw600">
								{{getCurrency()}}<span class="ml5"> {{item.deduction_num}}</span>
							</div>
							<div class="mt-1">
								<div class="ft14 cl-black">
									{{ $t('userCenter.minimumConsumption') }}:{{getCurrency()}}{{item.satisfy_num}}
								</div>
								<div class="ft14 cl-red" v-if="item.validity_type==3||item.validity_type==2">
									{{ $t('userCenter.validTime') }}{{item.validity_finish_time}}
								</div>
								<div v-else>無失效日期</div>
							</div>
						</div>
					</div>
				</div>
				<div class="mt-4">
					<div class="d-flex">
						<div class=" clickAct cl-info me-5" @click="recommendTab = 1"
							:class="recommendTab == 1?'userCenter-tab-select':'userCenter-tab'">
							{{ $t('userCenter.personalizedRecommendation') }}
						</div>
						<div class=" clickAct cl-info" @click="recommendTab = 2"
							:class="recommendTab == 2?'userCenter-tab-select':'userCenter-tab'">
							{{ $t('userCenter.todayHot') }}
						</div>
					</div>
					<div class="row mt-4">
						<div class="col-md-4 mm-r-t" v-for="(item,index) in teacherList">
							<div class="card shadow-sm ">
								<video :src="item.video_files[0] " v-if="item.video_files" autoplay controls
									class="bd-placeholder-img card-img-top" style="width: 100%;height: 185px;"></video>
								<div class="p-3">
									<div class="flex alcenter">
										<img :src="item.photo_image" alt="" class="userCenter-card-head" />
										<div class="ml10">
											<div class="">
												{{item.name}} {{item.surname}}
											</div>
											<div class="ft12 cl-info">
												{{ $t('userCenter.fromUK') }}
											</div>
										</div>
									</div>
									<div class="mt-3">
										<span class="cl-info">{{item.language_name}}</span> <span class="cl-theme">
											{{ $t('userCenter.nativeLanguage') }} </span>
									</div>
									<div class="flex alcenter mt-2 ">
										<div class="">
											<div class="ft12 cl-info">
												{{ $t('userCenter.hourlyCharge') }}
											</div>
											<div class="">
												{{getCurrency()}} 93.30
											</div>
										</div>
										<div class="ml20">
											<div class="ft12 cl-info">
												{{ $t('userCenter.ticketPackage') }}
											</div>
											<div class="">
												15% {{ $t('userCenter.discount') }}
											</div>
										</div>
									</div>
									<div class="mt-2 ft12 cl-info">
										{{ $t('userCenter.recommendationReason') }}
									</div>
									<div class="mt-1 ft12 cl-info">
										两方都精港奥
									</div>
									<div class="mt-1 ft12 cl-info">
										有以想学昔月的高主的模程
									</div>
									<button type="button" class="btn btn-theme mt-4 py-2" style="width: 100%;">
										{{ $t('userCenter.bookNow') }} </button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md mm-r-t">
				<div class="ftr-1-25 ftw600">
					{{$t('userCenter.todolist')}}
				</div>
				<div class="mt-3 mb-3" :style="{ width: '300px', border: '1px solid #d9d9d9', borderRadius: '4px' }">
					<a-calendar  :fullscreen="false" @panelChange="" />
				</div>
				
				<div class="ftr-1-25 ftw600">
					{{ $t('userCenter.toDoList') }}
				</div>
				<div class="mt-3 border-gray br4 p-3" style="max-width: 400px;"
					v-for="(item,index) in disCoursePackageList">
					<div class="cl-red ftw600">
						{{ $t('userCenter.timeLimitedOffer') }}
					</div>
					<div class="mt-2 d-flex align-items-center">
						<img :src="item.photo_image" alt="" class="userCenter-head" />
						<div class="cl-17AAEA ml10 ftw600">
							{{item.name}} {{item.surname}}
						</div>
					</div>
					<div class="ftw600 mt-1">
						<!-- 正式课 -->
						{{$t('becomeTeacher.formalClass')}}
					</div>
					<div class="flex alcenter">
						<div style="width: 50px;"> {{$t('forClassIndex.class')}}:</div>{{item.course_name}}
					</div>
					<div class="flex alcenter">
						<div style="width: 50px;"> {{$t('appointment.coursePackage')}}:</div>
						{{$t('common.numberClass',{num:item.quantity})}} x
						{{getCurrency()}}{{convertCurrency(item.once_price)}}(50{{$t('forClassIndex.minute')}})
					</div>
					<div class="flex alcenter">
						<div style="width: 50px;"> {{$t('userCenter.timeLimit')}}:</div>
						{{convertToTimeZone(item.finish_time).formattedTime}}
					</div>
					<div class="d-flex flex-column align-items-center mt-2">
						<button type="button" class="btn btn-theme bg-theme border-theme px-5"
							@click="toCashDesk(item)">{{ $t('userCenter.purchase') }}</button>
						<div class="ft14 cl-red flex alcenter">
							{{ $t('userCenter.remainingTime') }}
							<countdown :targetTime="convertToTimeZone(item.finish_time).formattedTime" />
						</div>
					</div>
				</div>
				
				
				<div class="mt-3 border-gray br4 p-3" style="max-width: 400px;"
					v-for="(item,index) in courseSaleList">
					<div class="cl-red ftw600">
						{{ $t('userCenter.limitedPromotion') }}
					</div>
					<div class="mt-2 d-flex align-items-center">
						<img :src="item.teacher_photo_image" alt="" class="userCenter-head" />
						<div class="cl-17AAEA ml10 ftw600">
							{{item.teacher_name}} {{item.teacher_surname}}
						</div>
					</div>
					<div class="ftw600 mt-1">
						<!-- 正式课 -->
						{{$t('becomeTeacher.formalClass')}}
					</div>
					<div class="flex alcenter">
						<div style="width: 50px;"> {{$t('forClassIndex.class')}}:</div>{{item.course_classify_name}} {{item.course_name}}
					</div>
					<div class="flex alcenter">
						<div style="width: 50px;"> {{$t('appointment.coursePackage')}}:</div>
						{{$t('common.numberClass',{num:item.quantity})}} x
						{{getCurrency()}}{{convertCurrency(item.price/item.quantity)}}(50{{$t('forClassIndex.minute')}})
					</div>
					<div class="flex alcenter">
						<div style="width: 50px;"> {{$t('userCenter.timeLimit')}}:</div>
						{{convertToTimeZone(item.finish_time).formattedTime}}
					</div>
					<div class="d-flex flex-column align-items-center mt-2">
						<button type="button" class="btn btn-theme bg-theme border-theme px-5"
							@click="toCashDesk(item,true)">{{ $t('userCenter.purchase') }}</button>
						<div class="ft14 cl-red flex alcenter">
							{{ $t('userCenter.remainingTime') }}
							<countdown :targetTime="convertToTimeZone(item.finish_time).formattedTime" />
						</div>
					</div>
				</div>
				
				
				<div class="mt-3 border-gray br4 p-3" style="max-width: 400px;" v-for="(item,index) in waitList">
					<div class="ftw600">
						{{ $t('userCenter.teacherAppointmentConfirm') }}
					</div>
					<div class="mt-2 d-flex align-items-center">
						<img :src="item.photo_image" alt="" class="userCenter-head" />
						<div class="cl-17AAEA ml10 ftw600">
							{{item.name}}{{item.surname}}
						</div>
					</div>
					<div class="cl-info">
						{{$t('appointment.coursePackage')}}:{{$t('teacherVue.formalClassTime',{number:'20'})}}{{item.course_name}}
					</div>
					<div class="cl-info border-b pb10">
						{{ $t('userCenter.timeZone') }}:{{timeZone}}
					</div>
					<div class="cl-info mt-2 d-flex flex-column align-items-center border-b pb10">
						{{convertToTimeZone(item.start_time).date.year}}/{{convertToTimeZone(item.start_time).date.month}}/{{convertToTimeZone(item.start_time).date.day}}({{changeNum(convertToTimeZone(item.start_time).date.week)}})
						{{convertToTimeZone(item.start_time).date.hour}}:{{convertToTimeZone(item.start_time).date.minute}}
						-
						{{convertToTimeZone(item.finish_time).date.hour}}:{{convertToTimeZone(item.finish_time).date.minute}}
					</div>
					<div class="d-flex mt-2 justify-content-center">
						<button type="button" class="btn btn-theme" style="width: 45%;"
							@click="toteacherConfirms(item.id)">{{ $t('userCenter.confirm') }}</button>
						<button type="button" class="btn btn-outline-theme ml15" style="width: 45%;"
							@click="toteacherConfirms(item.id)">{{ $t('userCenter.reject') }}</button>
					</div>
					<div class="flex center alcenter mt-2 cl-red">
						<div class="iconfont icon-shijian_fuzhi cl-black mr10"></div>
						{{$t('userCenter.remainingTime')}} <countdown :targetTime="item.djsTime" />
					</div>
					
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	import countdown from '../../../components/countdown.vue'
	export default {
		components: {
			countdown
		},
		data() {
			return {
				coursePackageList: [],
				orderList: [],
				waitList: [], //待办事项
				workInfo: {
					work_num: 0,
					work_complete: 0,
					test_num: 0,
					test_complete: 0,
					report_num: 0,
				},
				recommendTab: 1,
				teacherList: [],
				disCoursePackageList: [],
				timeZone: localStorage.getItem('timeZone'),
				
				coursePackageBanner:0,
				couponList:[],
				courseSaleList:[]
			}
		},
		created() {
			this.coursePackage()
			this.getOrderList()
			this.getWait()
			this.appendixList()
			this.reportList()
			this.getTeacherList()
			this.getDisCoursePackage()
			this.getCouponList()
			this.teacherCourseSaleList()
		},
		methods: {
			toCashDesk(item,boo) {
				if(boo){
					this.$router.push('/cashDesk?item=' + JSON.stringify(item)+'&teacher_course_sale_id='+item.id)
				}else{
					this.$router.push('/cashDesk?item=' + JSON.stringify(item))
				}
				
			},
			toClass(id) {
				// this.$emit('select', index)
				this.$router.push('/teacherConfirms?id=' + id)
			},
			toteacherConfirms(id) {
				this.$router.push('/teacherConfirms?id=' + id)
			},

			toAppointment(id) {
				console.log("---执行");
				this.$router.push('/appointment?id=' + id)
			},
			getCouponList(){
				this.$http.api('user/couponList').then(res=>{
					this.couponList = res.list
				})
			},
			teacherCourseSaleList(){
				this.$http.api('user/teacherCourseSaleList', {}).then(res=>{
					console.log("res",res.list);
					this.courseSaleList = res.list
				})
			},
			
			coursePackage() {
				this.$http.api('user/coursePackage', {
					// is_experience:1,
					// status:1
				}).then(res => {
					
					let arr = [] , list = []
					res.list.forEach((item,index)=>{
						if(item.residue_quantity!=0){
							if(arr.length<5&&index%4<=3){
								arr.push(item)
							}
							if(arr.length==4){
								list.push(arr)
								arr = []
							}
						}
						
					})
					if(arr.length!=0) list.push(arr)
					this.coursePackageList = list
					console.log("-----------this.coursePackageList",this.coursePackageList);
					
					
				})
			},
			// 预约课堂的列表
			getOrderList() {
				this.$http.api('reservation/orderList', {
					page: 1,
					limit: 6
				}).then(res => {
					// this.orderList = res.list
					let arr = [] , list = []
					res.list.forEach((item,index)=>{
						if(arr.length<4&&index%4<=3){
							arr.push(item)
						}
						if(arr.length==3){
							list.push(arr)
							arr = []
						}
					})
					if(arr.length!=0) list.push(arr)
					
					// console.log("-----------123",list);
					this.orderList = list
				})
			},
			// 待办事项
			getWait() {
				this.$http.api('reservation/orderList', {
					page: 1,
					limit: 1000,
					status: 1,
					order_type: 2,//老师发起
					confirmation_status: 2,//未确认状态
				}).then(res => {
					this.waitList = res.list
					this.waitList.forEach((item,index)=>{
						// 创建一个 Date 对象，表示当前时间
						let currentDate = new Date(item.updatetime);
						
						// 添加 12 小时
						currentDate.setHours(currentDate.getHours() + 12);
						
						// 格式化为 'YYYY-MM-DD HH:mm:ss'
						let formattedDate = currentDate.toISOString().replace('T', ' ').slice(0, 19);
						item.djsTime = formattedDate
						console.log(formattedDate);
					})
					
				})
			},
			getDisCoursePackage() {
				this.$http.api('marketing/discountedCoursePackage', {}).then(res => {
					this.disCoursePackageList = res.list
				})
			},
			appendixList() {
				// 附录类型:1=笔记,2=作业,3=测验
				this.$http.api('reservation/appendixList', {
					status: 2
				}).then(res => {

				})
				this.$http.api('reservation/appendixList', {
					status: 3
				}).then(res => {

				})

			},
			// 报告列表
			reportList() {
				this.$http.api('user/reportList', {
					page: 1,
					limit: 1000,
				}).then(res => {
					this.workInfo.report_num = res.list ? res.list.length : ''
				})
			},
			getTeacherList() {
				this.$http.api('teachers/teacherList', {
					page: 1,
					limit: 3,
					random_sort: 1,
				}).then(res => {
					this.teacherList = res.list
				})
			}
		}
	}
</script>

<style scoped>
	/* 轮播图 */
	.ant-carousel .custom-slick-arrow {
		width: 40px;
		height: 40px;
		font-size: 30px;
		color: #000;
		/* background-color: rgba(31, 45, 61, 0.11); */
		opacity: 0.5;
		border-radius: 50%;
		text-align: center;
		line-height: 30px;
	}

	.ant-carousel .custom-slick-arrow:before {
		display: none;
	}

	.ant-carousel .custom-slick-arrow:hover {
		opacity: 0.5;
	}

	::v-deep .ant-carousel .slick-dots li button {
		/* background-color: #C9C9C8; */
		width: 15px;
		height: 15px;
	}

	::v-deep.ant-carousel .slick-dots li.slick-active button {
		background-color: transparent;
		width: 20px;
		height: 20px;
	}
	.userCenter-head {
		width: 40px;
		height: 40px;
		border-radius: 50%;
	}

	.progress {
		height: 8px !important;
	}

	.userCenter-tab {}

	.userCenter-tab-select {
		color: #52C4C9;
		border-bottom: 1px solid #52C4C9;
	}

	.userCenter-card-head {
		width: 40px;
		height: 40px;
		border-radius: 50%;
	}
</style>